$shm_hitalama_version_label $mol_view
	version \
	date \
	sub /
		<= title \
